import useDynamicComponent from "../../components/dynamics/useDynamicComponent";

export type AssistancesFromClientProps = {
    clientErpId?: string | null;
    clientName?: string | null;
    showCreateNewAssistanceButton?: boolean | null;
    showKpiClientAssistancesHistoryDashboardButton?: boolean | null;
};

export default function AssistancesFromClient({ clientErpId, clientName, showCreateNewAssistanceButton, showKpiClientAssistancesHistoryDashboardButton }: AssistancesFromClientProps) {
    const MainContent = useDynamicComponent("AssistancesFromClient", { clientErpId, clientName, showCreateNewAssistanceButton, showKpiClientAssistancesHistoryDashboardButton });
    return (
        <div>
            {MainContent}
        </div>
    );
}